module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('search-select', {
    attrs: {
      "selected": _vm.currentSelected,
      "options": _vm.options,
      "placeholder": '请输入搜索内容'
    },
    on: {
      "search": _vm.search,
      "change": _vm.selectChange
    }
  }), _c('search-select', {
    ref: "subSearchSelect",
    attrs: {
      "selected": _vm.currentSubSelected,
      "options": _vm.subOptions,
      "placeholder": '请输入搜索内容'
    },
    on: {
      "search": _vm.subsearch,
      "change": _vm.subselectChange
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b278f6e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b278f6e6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/casecade.vue
// module id = 791
// module chunks = 0